// src/utils/request.js
import axios from 'axios'
import { Message, Loading } from 'element-ui'

// 创建 axios 实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // 从你配置的.env文件读取
  baseURL: '/construction',
  timeout: 15000
})

// 全局 loading 实例
let loadingInstance = null

// ==================== 请求拦截器 ====================
service.interceptors.request.use(
  config => {
    // 打开 loading
    loadingInstance = Loading.service({
      lock: true,
      text: '',
      background: 'rgba(0, 0, 0, 0.1)'
    })

    // 自动携带 token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }

    return config
  },
  error => {
    // 关闭 loading
    if (loadingInstance) loadingInstance.close()
    return Promise.reject(error)
  }
)

// ==================== 响应拦截器 ====================
service.interceptors.response.use(
  response => {
    // 关闭 loading
    if (loadingInstance) loadingInstance.close()

    const res = response.data

    // 后端约定：code === 200 为成功
    if (res.code !== 1) {
      Message({
        message: res.msg || '请求失败',
        type: 'error',
        duration: 3 * 1000
      })

      // 401：token 过期
      if (res.code === 401) {
        localStorage.removeItem('token')
        Message.warning('登录已过期，请重新登录')
        // 这里可以加跳转到登录页逻辑
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    if (loadingInstance) loadingInstance.close()

    Message({
      message: error.message || '网络异常',
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

// ==================== 导出常用请求方法 ====================
export default service

export const get = (url, params, config) => {
  return service.get(url, { params, ...config })
}

export const post = (url, data, config) => {
  return service.post(url, data, config)
}

export const put = (url, data, config) => {
  return service.put(url, data, config)
}

export const del = (url, params, config) => {
  return service.delete(url, { params, ...config })
}
